import { get } from 'lodash';
export const analyzeCallNew = (call, analysisConfig) => {
    const callMessages = call.transcript || [];
    const relevantCallData = {
        endedReason: call.endedReason,
        analysis: call.analysis,
        transferDestination: call.transferDestination,
        actions: callMessages
            .filter((m) => m.role === 'tool_calls')
            .filter((m) => m.toolCalls.length > 0)
            .map((m) => m.toolCalls[0]?.function.name)
            .filter((name) => name !== undefined)
    };
    // Filter config check
    const flatConfig = analysisConfig.flat();
    const relevantFlatConfig = flatConfig.filter((config) => config.objKey === 'endedReason' ||
        config.objKey === 'transferDestination' ||
        config.objKey === 'action.name' ||
        config.objKey.startsWith('analysis.'));
    if (flatConfig.length !== relevantFlatConfig.length) {
        return false;
    }
    // Analyze the call data
    const analysisResult = analysisConfig.map((orBlock) => {
        return orBlock.every((condition) => {
            if (condition.objKey === 'action.name') {
                if (condition.operation === 'equals') {
                    return relevantCallData.actions.includes(condition.objValue);
                }
                if (condition.operation === 'not-equals') {
                    return !relevantCallData.actions.includes(condition.objValue);
                }
                if (condition.operation === 'contains') {
                    return relevantCallData.actions.some((action) => action.includes(condition.objValue));
                }
                if (condition.operation === 'not-contains') {
                    return !relevantCallData.actions.some((action) => action.includes(condition.objValue));
                }
                return false;
            }
            const data = get(relevantCallData, condition.objKey);
            if (condition.operation === 'equals') {
                return data === condition.objValue;
            }
            if (condition.operation === 'not-equals') {
                return data !== condition.objValue;
            }
            if (condition.operation === 'contains') {
                return data?.includes(condition.objValue);
            }
            if (condition.operation === 'not-contains') {
                return !data?.includes(condition.objValue);
            }
            if (condition.operation === 'greater-than') {
                return data > condition.objValue;
            }
            if (condition.operation === 'less-than') {
                return data < condition.objValue;
            }
            if (condition.operation === 'greater-than-or-equal') {
                return data >= condition.objValue;
            }
            if (condition.operation === 'less-than-or-equal') {
                return data <= condition.objValue;
            }
            return false;
        });
    });
    return analysisResult.some((result) => result);
};
//# sourceMappingURL=analyze-call-new.js.map